module.exports = __webpack_public_path__ + "Oswald-VariableFont_wght.ttf?a6e5446a7c5789aabc9b37eaaf72134d";